// extracted by mini-css-extract-plugin
export default {"page":"A2-z","cartModal":"B2-z","checkout":"C2-z","placeholder":"D2-z","account":"E2-z"};